import { Alarm, DataVersion } from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useAlarm(
  id: string,
  partitionKey?: string,
  dataVersion?: DataVersion
) {
  const url = `/v2/orm/alarm/${id}${
    partitionKey ? `?partitionKey=${partitionKey}` : ''
  }`;
  const request = new Request(url);
  withDataVersion(request, dataVersion);

  return useAuthenticatedRequest<Alarm>(request, {
    queryKey: ['alarms', id, dataVersion],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}

export default useAlarm;
